import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import {
  storeUserData,
  loadAllClaims,
  loadAllClaimsSuccess,
  loadAllClaimsFailure,
  storeUserDataSuccess,
  storeUserDataFailure,
} from './user-data.actions';
import { ApiUsersApiService } from '../../shared/api-services/api-services';
import { UserDataDto } from '../../shared/models/user-data.dto';

@Injectable()
export class UserDataEffects {
  public userData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(storeUserData),
      concatMap(({ data }) => {
        return this.userData(data).pipe(
          map((_) => storeUserDataSuccess({ data: new UserDataDto(_) })),
          catchError((error) => of(storeUserDataFailure({ error })))
        );
      })
    )
  );

  allClaims$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAllClaims),
      concatMap(() => {
        return this.client.getPermissionsDictionary().pipe(
          map((_) => loadAllClaimsSuccess({ data: _ })),
          catchError((error) => of(loadAllClaimsFailure({ error })))
        );
      })
    )
  );

  private userData(data: UserDataDto) {
    return of(data);
  }

  constructor(private actions$: Actions, private client: ApiUsersApiService) {}
}
